<div class="tab-pane" role="tabpanel" id="predios">
    <fieldset id="agregar_predios" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <h3 class="form-signin-heading"><strong>Porcentajes</strong></h3>
                        <hr />
                        <div class="form-horizontal">
                            <div class="form-group col-md-12">
                                <div *ngIf="number == '3.1'"><strong>Predios resultantes:</strong></div>
                                <div *ngIf="number == '3.6'"><strong>Lotes:</strong></div>
                                <div *ngIf="number == '4.1'"><strong>Lotes Resultantes:</strong></div>
                            </div>
                            <br />
                            <br />
                            <div class="form-group col-md-12" style="padding-bottom: 30px">

                                <div class="col-md-1">
                                    <label for="sup_predios" class="labelEdi1">Superficie</label>
                                </div>
                                <div class="col-md-2" style="margin-left: 40px ; margin-right: 15px">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="M2" id="sup_predios" name="sup_predios" formControlName="sup_predios" (change)="add_porcentajes_anteproy()"  />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1">
                                    <label for="porc_predios" class="labelEdi2">Porcentaje</label>
                                </div>
                                <div class="col-md-2" style="margin-left: 50px ; margin-right: 15px">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="%" id="porc_predios" name="porc_predios" formControlName="porc_predios" (change)="add_porcentajes_anteproy()"  />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1">
                                    <label for="cant_predios" class="labelEdi3">Cantidad</label>
                                </div>
                                <div class="col-md-2" style="margin-left: 50px ; margin-right: 15px">
                                    <mat-form-field class="example-full-width" style="width: 145px ; ">
                                        <input matInput placeholder="" id="cant_predios" name="cant_predios" formControlName="cant_predios" (change)="add_porcentajes_anteproy()"  />
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="form-group  col-md-12">
                                <div *ngIf="number != '4.1'"><strong>Areas Verdes:</strong></div>
                                <div *ngIf="number == '4.1'"><strong>Parques:</strong></div>
                            </div>
                            <br />
                            <br />
                            <div class="form-group col-md-12" style="padding-bottom: 30px">

                                <div class="col-md-1">
                                    <label for="sup_areas" class="labelEdi1">Superficie</label>
                                </div>
                                <div class="col-md-2" style="margin-left: 40px ; margin-right: 15px">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="M2" id="sup_areas" name="sup_areas" formControlName="sup_areas" (change)="add_porcentajes_anteproy()"  />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1">
                                    <label for="porc_areas" class="labelEdi2">Porcentaje</label>
                                </div>
                                <div class="col-md-2" style="margin-left: 50px ; margin-right: 15px">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="%" id="porc_areas" name="porc_areas" formControlName="porc_areas" (change)="add_porcentajes_anteproy()"  />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1">
                                    <label for="cant_areas" class="labelEdi3">Cantidad</label>
                                </div>
                                <div class="col-md-2" style="margin-left: 50px ; margin-right: 15px">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput id="cant_areas" name="cant_areas" formControlName="cant_areas" (change)="add_porcentajes_anteproy()"  />
                                    </mat-form-field>
                                </div>
                            </div>
                            <div *ngIf="number != '4.1'">
                                <div class="form-group col-md-12">
                                    <div><strong>Equipamiento:</strong></div>
                                </div>
                                <br />
                                <div class="form-group col-md-12" style="padding-bottom: 30px">
                                    <div class="col-md-1">
                                        <label for="sup_equip" class="labelEdi1">Superficie</label>
                                    </div>
                                    <div class="col-md-2" style="margin-left: 40px ; margin-right: 15px">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput placeholder="M2" id="sup_equip" name="sup_equip" formControlName="sup_equip" (change)="add_porcentajes_anteproy()"  />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-1">
                                        <label for="porc_equip" class="labelEdi2">Porcentaje</label>
                                    </div>
                                    <div class="col-md-2" style="margin-left: 50px ; margin-right: 15px">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput placeholder="%" id="porc_equip" name="porc_equip" formControlName="porc_equip" (change)="add_porcentajes_anteproy()"  />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-1">
                                        <label for="cant_equip" class="labelEdi3">Cantidad</label>
                                    </div>
                                    <div class="col-md-2" style="margin-left: 50px ; margin-right: 15px">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput id="cant_equip" name="cant_equip" formControlName="cant_equip" (change)="add_porcentajes_anteproy()"  />
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-md-12">
                                    <div><strong>Vialidad:</strong></div>
                                </div>
                                <br />
                            <div class="form-group col-md-12" style="padding-bottom: 30px">
                                <div class="col-md-1">
                                    <label for="sup_valid" class="labelEdi1">Superficie</label>
                                </div>
                                <div class="col-md-2" style="margin-left: 40px ; margin-right: 15px">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="M2" id="sup_valid" name="sup_valid" formControlName="sup_valid" (change)="add_porcentajes_anteproy()"  />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1">
                                    <label for="porc_valid" class="labelEdi2">Porcentaje</label>
                                </div>
                                <div class="col-md-2" style="margin-left: 50px ; margin-right: 15px">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="%" id="porc_valid" name="porc_valid" formControlName="porc_valid" (change)="add_porcentajes_anteproy()"  />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1">
                                    <label for="cant_valid" class="labelEdi3">Cantidad</label>
                                </div>
                                <div class="col-md-2" style="margin-left: 50px ; margin-right: 15px">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput id="cant_valid" name="cant_valid" formControlName="cant_valid" (change)="add_porcentajes_anteproy()"  />
                                    </mat-form-field>
                                </div>
                            </div>
                            <div *ngIf="number != '4.1'">
                                <div class="form-group col-md-12">
                                        <div><strong>Reserva propietario:</strong></div>
                                    </div>
                                    <br />
                                    <div class="form-group col-md-12" style="padding-bottom: 30px">
                                        <div class="col-md-1">
                                            <label for="sup_reserva" class="labelEdi1">Superficie</label>
                                        </div>
                                    <div class="col-md-2" style="margin-left: 40px ; margin-right: 15px">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput placeholder="M2" id="sup_reserva" name="sup_reserva" formControlName="sup_reserva" (change)="add_porcentajes_anteproy()"  />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-1">
                                        <label for="porc_reserva" class="labelEdi2">Porcentaje</label>
                                    </div>
                                    <div class="col-md-2" style="margin-left: 50px ; margin-right: 15px">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput placeholder="%" id="porc_reserva" name="porc_reserva" formControlName="porc_reserva" (change)="add_porcentajes_anteproy()"  />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-1">
                                        <label for="cant_reserva" class="labelEdi3">Cantidad</label>
                                    </div>
                                    <div class="col-md-2" style="margin-left: 50px ; margin-right: 15px">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput id="cant_reserva" name="cant_reserva" formControlName="cant_reserva" (change)="add_porcentajes_anteproy()"  />
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </fieldset>
</div>